<template>
  <main>
    <div class="login-container">
      <div class="login-logo">
        <img src="@/assets/images/login-logo.svg" />
      </div>
      <form class="login-form" @submit.prevent="error = login()">
        <p v-if="error">
          <em>{{ error }}</em>
        </p>
        <input
          class="input-code"
          type="password"
          placeholder="Code"
          size="20"
          v-model="code"
          required
        />
        <div class="submit-div">
          <img
            class="half-circle"
            src="@/assets/images/half-circle-white_v-18.svg"
          />
          <div class="login-btn-container">
            <input type="submit" class="login-btn" value />
            <p style="margin-left: 26px; color: #03AAA8; font-size: 22px;">
              Enter
            </p>
          </div>
        </div>
      </form>
    </div>
    <!-- <form @submit.prevent="login">
      <div class="input-group">
        <p v-if="error">
          <em>{{ error }}</em>
        </p>
        <label for="code">Code:</label>
        <input id="code" type="password" v-model="code" required />

        <button type="submit">Enter</button>
      </div>
    </form> -->
    <div class="background"></div>
  </main>
</template>

<script>
import { http } from '@/plugins/HttpPlugin';
import router from '@/router';

async function login(code, tommId = undefined, noteId = undefined, assessorId = undefined) {
  try {
    await http.put('/survey/login', { code: code, tommId, noteId, assessorId });
  } catch ({ response }) {
    if (response.status === 404) {
      return response.data.message;
    } else if (response.status === 422) {
      return response.data.errors.code.join('\n');
    }

    return;
  }

  await router.push({ name: 'survey-question' });
}

export default {
  name: 'survey-login',

  data() {
    return {
      code: '',
      tommId: null,
      error: '',
    };
  },

  beforeRouteEnter(to, from, next) {
    const tommId = to.query.tomm_id;
    const code = to.query.code;
    const noteId = to.query.note_id;
    const assessorId = to.query.assessor_id;

    if(code && tommId && assessorId) {
      login(code, tommId, noteId, assessorId).then(error => {
        if (error) next();
      });
    } else if (code && tommId && noteId) {
      login(code, tommId, noteId).then(error => {
        if (error) next();
      });
    } else if (code && tommId) {
      login(code, tommId).then(error => {
        if (error) next();
      });
    } else {
      next();
    }
  },

  methods: {
    async login() {
      await login(this.code);
    },
  },
};
</script>

<style lang="scss" scoped>
.background {
  background: transparent url('../../assets/images/background.jpg') repeat
    scroll 0% 0% / cover;
  position: absolute;
  left: 0px;
  width: 100%;
  z-index: -1;
  bottom: 0px;
  height: 67%;
}

.login-container {
  display: block;
  padding: 0;
  width: 35%;
  position: absolute;
  top: 8%;
  left: 50%;
  margin-left: -17.5%;
}

.login-logo {
  height: 8vh;
  text-align: center;
}

.login-form {
  padding: 0px;
  box-shadow: unset;
  background: transparent;
  width: 100%;
  margin-top: 5vh;
  border-radius: 15px;
}

.input-code {
  visibility: visible;
  margin-top: 5vh;
  border: none;
  box-shadow: unset;
  padding: 10px 30px;
  height: 6vh;
  position: relative;
  z-index: 1;
  font-size: 14px;
  width: 100%;
  background: #e7f7f6;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.input-code:focus {
  outline: none;
}

.submit-div {
  position: relative;
}

.half-circle {
  width: 101%;
  margin-left: -0.5%;
  margin-top: -1p;
}

.login-btn-container {
  position: absolute;
  top: 10%;
  left: 50%;
  width: 100px;
  margin-left: -50px;
}

.login-btn {
  background: url('../../assets/images/login-btn.svg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 100px;
  width: 100px;
  border: none;
  cursor: pointer;
}
</style>
